'use client';

import { useRouter, useSearchParams } from 'next/navigation';

import { CrossIcon } from '@/components/ui/Icons/Icons';
import { ROUTES } from '@/constants/common';
import { decodeFromBase64 } from '@/utils/helpers/base64';

import * as S from './AuthWrapper.styles';

const { HOME } = ROUTES;

export const CrossButton = () => {
  const { push } = useRouter();
  const searchParams = useSearchParams();

  const returnTo = searchParams.get('returnTo') || '';

  const handleGoBack = () => {
    const prevRoute = decodeFromBase64(returnTo);
    if (prevRoute) {
      return push(prevRoute);
    }
    push(HOME);
  };

  return (
    <S.CrossButton onClick={handleGoBack}>
      <CrossIcon />
    </S.CrossButton>
  );
};
